import { MobiDocument } from './MobiDocument';

export class SupplementPointageDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private pointage_id: number;
    private supplement_id: number;
    private checked: boolean;

    public constructor(supplementPointage: any) {
        super()
        this._id = supplementPointage._id;
        this._rev = supplementPointage._rev;
        this.id = supplementPointage.id;
        this.pointage_id = supplementPointage.pointage_id;
        this.supplement_id = supplementPointage.supplement_id;
        this.checked = supplementPointage.checked;
    }
    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getPointage_id(): number {
        return this.pointage_id;
    }

    public setPointage_id(pointage_id: number): void {
        this.pointage_id = pointage_id;
    }

    public getSupplement_id(): number {
        return this.supplement_id;
    }

    public setSupplement_id(supplement_id: number): void {
        this.supplement_id = supplement_id;
    }

    public isChecked(): boolean {
        return this.checked;
    }

    public setChecked(checked: boolean): void {
        this.checked = checked;
    }


}
